import { useEffect } from "react";
import { useNavigate } from "react-router";
import { PageHeader } from "@/components/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import { useAdminAccess } from "@/lib/hooks/use-admin";
import { PartnerTenantsWrapper } from "./partner-tenants-wrapper";

export default function PartnerTenantsPage() {
  const navigate = useNavigate();
  const { isLoading, isPartner, canViewAdmin } = useAdminAccess();
  // The partner's own tenant list — quantfolio admins use /tenants instead.
  const canView = canViewAdmin && isPartner;

  useEffect(() => {
    if (isLoading) return;
    if (!canView) {
      navigate("/", { replace: true });
    }
  }, [isLoading, canView, navigate]);

  if (isLoading || !canView) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-64" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumbs={[{ label: "Admin", href: "/admin" }, { label: "Tenants" }]}
        title="Tenants"
        description={"Manage your organization's sub-tenants"}
      />

      <PartnerTenantsWrapper />
    </div>
  );
}
